import axios from 'axios';

export default class LaunchDarkly {
  constructor({ baseURL }) {
    this.baseURL = baseURL;
  }

  async getSdeStatus(accountId) {
    const result = await axios.get(`${this.baseURL}/${accountId}/ld/sdestatus`);
    return result.data;
  }

  async setSdeStatus(accountId, status) {
    const result = await axios.post(`${this.baseURL}/${accountId}/ld/sdestatus`, {
      status,
    });
    return result.data;
  }
}
